module.exports = __webpack_public_path__ + "static/media/19ESCAP2.588361e4.jpg";